import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import ScrollToTop from '@/components/ScrollToTop';
import FloatingContactButton from '@/components/FloatingContactButton';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PortfolioPage from '@/pages/PortfolioPage';
import ShowerGlassPage from '@/pages/ShowerGlassPage';
import WineEnclosuresPage from '@/pages/WineEnclosuresPage';
import OfficePartitionsPage from '@/pages/OfficePartitionsPage';
import MirrorsPage from '@/pages/MirrorsPage';
import StorefrontPage from '@/pages/StorefrontPage';
import GlassRailingsPage from '@/pages/GlassRailingsPage';
import ResourcesPage from '@/pages/ResourcesPage';
import FAQPage from '@/pages/FAQPage';
import CareersPage from '@/pages/CareersPage';
import PaymentSuccessPage from '@/pages/PaymentSuccessPage';
import SqueegeeGamePage from '@/pages/SqueegeeGamePage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import LocalServicePage from '@/pages/LocalServicePage';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import { getLocalRoutes } from '@/data/localServiceData';
import '@/App.css';

const localRoutes = getLocalRoutes();

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/shower-glass" element={<ShowerGlassPage />} />
            <Route path="/wine-enclosures" element={<WineEnclosuresPage />} />
            <Route path="/office-partitions" element={<OfficePartitionsPage />} />
            <Route path="/mirrors" element={<MirrorsPage />} />
            <Route path="/storefront-curtain-walls" element={<StorefrontPage />} />
            <Route path="/glass-railings" element={<GlassRailingsPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/success" element={<PaymentSuccessPage />} />
            <Route path="/squeegee" element={<SqueegeeGamePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            {localRoutes.map(route => (
              <Route key={route.path} path={route.path} element={<LocalServicePage serviceSlug={route.serviceSlug} citySlug={route.citySlug} />} />
            ))}
          </Routes>
        </Layout>
        <FloatingContactButton />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
